import { useEffect, useState } from 'react';
import useDebounce from '@teetsh/app/src/utils/useDebounce';
import { LivretEleveCompetence } from '@teetsh/app/src/containers/Livrets/types/livret';
import { useUpdateLivretCompetence } from '@teetsh/app/src/containers/Livrets/queries/competences/useUpdateLivretCompetence';

export function useUpdateLivretCompetenceDebounced({
  competence: comp,
  livretEleveId,
  livretEvalId,
  matiereId,
  domaineId,
}: {
  competence: LivretEleveCompetence;
  livretEleveId: string;
  livretEvalId: string;
  matiereId: string;
  domaineId?: string;
}): [LivretEleveCompetence, (v: LivretEleveCompetence) => void] {
  const [competence, setCompetence] = useState<LivretEleveCompetence>(comp);
  const update = useUpdateLivretCompetence({
    livretEleveId,
    livretEvalId,
  });
  const debouncedSave = useDebounce<(v: LivretEleveCompetence) => Promise<any>>(
    nextValue =>
      update({
        id: nextValue.id,
        matiereId,
        domaineId,
        name: nextValue.name,
        note: nextValue.note,
      }),
    500,
  );
  useEffect(() => {
    setCompetence(comp);
  }, [comp.id]);

  const handleChange = (v: LivretEleveCompetence) => {
    setCompetence(v);
    debouncedSave(v);
  };
  return [competence, handleChange];
}
